import { useState } from "react";
import { Maximize2 } from "lucide-react";
import PageHero from "@/components/PageHero";
import Lightbox from "@/components/Lightbox";
import CTABanner from "@/components/CTABanner";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/ContentContext";

export default function GalleryPage() {
  const D = useSite();
  const p = D.pages.galeri;
  const images = D.gallery;
  const [active, setActive] = useState(null);

  return (
    <>
      <PageHero overline={p.overline} titleLines={p.titleLines} description={p.description} />
      <section className="mx-auto max-w-7xl px-6 pb-28 md:px-12">
        <div className="columns-1 gap-6 space-y-6 sm:columns-2 lg:columns-3">
          {images.map((img, i) => (
            <Reveal key={img.src} delay={(i % 3) * 0.08} className="break-inside-avoid">
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(i)}
                aria-label={`${img.alt} görselini büyüt`}
                className="group relative block w-full overflow-hidden rounded-3xl shadow-premium transition-shadow duration-700 hover:shadow-lift"
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-[1200ms] ease-premium group-hover:scale-[1.07] ${img.ratio}`}
                />
                <div className="absolute inset-0 bg-charcoal-950/0 transition-colors duration-500 group-hover:bg-charcoal-950/35" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-all duration-500 ease-premium group-hover:opacity-100">
                  <span className="flex h-14 w-14 scale-75 items-center justify-center rounded-full border border-white/50 bg-white/20 text-white backdrop-blur-md transition-transform duration-500 ease-premium group-hover:scale-100">
                    <Maximize2 className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                </div>
                <p className="absolute bottom-4 left-5 translate-y-2 font-accent text-[11px] uppercase tracking-[0.25em] text-white opacity-0 transition-all duration-500 ease-premium group-hover:translate-y-0 group-hover:opacity-100">
                  {img.alt}
                </p>
              </button>
            </Reveal>
          ))}
        </div>
      </section>
      <Lightbox images={images} index={active} onClose={() => setActive(null)} onNavigate={setActive} />
      <CTABanner />
    </>
  );
}
